<template>
  <div v-if="editor != null">
    <div class="control-group d-flex justify-content-center mt-3 mb-3 mx-1">
      <!-- Undo/Redo -->
      <section>
        <div class="btn-group" role="group" aria-label="undo-redo">
          <button type="button" @click="editor.chain().focus().undo().run()" :disabled="!editor.can().chain().focus().undo().run()" class="btn border-0">
            <font-awesome-icon icon="arrow-rotate-left" />
          </button>

          <button type="button" @click="editor.chain().focus().redo().run()" :disabled="!editor.can().chain().focus().redo().run()" class="btn border-0">
            <font-awesome-icon icon="arrow-rotate-right" />
          </button>
        </div>
      </section>

      <div class="border-start border-2 mx-2"></div>

      <!-- Text decoration -->
      <section>
        <div class="btn-group" role="group" aria-label="Text decoration">
          <button
            type="button"
            @click="editor.chain().focus().toggleBold().run()"
            :disabled="!editor.can().chain().focus().toggleBold().run()"
            class="btn"
            :class="[editor.isActive('bold') ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="bold" />
          </button>

          <button
            type="button"
            @click="editor.chain().focus().toggleItalic().run()"
            :disabled="!editor.can().chain().focus().toggleItalic().run()"
            class="btn"
            :class="[editor.isActive('italic') ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="italic" />
          </button>

          <button
            type="button"
            @click="editor.chain().focus().toggleUnderline().run()"
            :disabled="!editor.can().chain().focus().toggleUnderline().run()"
            class="btn"
            :class="[editor.isActive('underline') ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="underline" />
          </button>

          <button
            type="button"
            @click="editor.chain().focus().toggleStrike().run()"
            :disabled="!editor.can().chain().focus().toggleStrike().run()"
            class="btn"
            :class="[editor.isActive('strike') ? 'btn-secondary' : 'boder-0']"
          >
            <font-awesome-icon icon="strikethrough" />
          </button>
        </div>

        <button
          @click="editor.chain().focus().toggleHighlight({ color: '#ffc078' }).run()"
          :class="{ 'is-active': editor.isActive('highlight', { color: '#ffc078' }) }"
          class="btn border-0 my-0 mx-1"
        >
          <div class="orange-cirlce"></div>
        </button>

        <div class="btn-group" role="group" aria-label="Text sub/super">
          <button
            type="button"
            @click="editor.chain().focus().toggleSubscript().run()"
            :disabled="!editor.can().chain().focus().toggleSubscript().run()"
            class="btn"
            :class="[editor.isActive('subscript') ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="subscript" />
          </button>

          <button
            type="button"
            @click="editor.chain().focus().toggleSuperscript().run()"
            :disabled="!editor.can().chain().focus().toggleSuperscript().run()"
            class="btn"
            :class="[editor.isActive('superscript') ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="superscript" />
          </button>
        </div>
      </section>

      <div class="border-start border-2 mx-2"></div>

      <!-- Lists -->
      <section>
        <div class="btn-group" role="group" aria-label="Lists">
          <button
            type="button"
            @click="editor.chain().focus().toggleOrderedList().run()"
            :disabled="!editor.can().chain().focus().toggleOrderedList().run()"
            class="btn"
            :class="[editor.isActive('orderedList') ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="list-ol" />
          </button>

          <button
            type="button"
            @click="editor.chain().focus().toggleBulletList().run()"
            :disabled="!editor.can().chain().focus().toggleBulletList().run()"
            class="btn"
            :class="[editor.isActive('bulletList') ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="list-ul" />
          </button>
        </div>
      </section>

      <div class="border-start border-2 mx-2"></div>

      <!-- Text alignment -->
      <section>
        <div class="btn-group" role="group" aria-label="Text alignment">
          <button
            type="button"
            @click="editor.chain().focus().setTextAlign('left').run()"
            class="btn"
            :class="[editor.isActive({ textAlign: 'left' }) ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="align-left" />
          </button>

          <button
            type="button"
            @click="editor.chain().focus().setTextAlign('center').run()"
            class="btn"
            :class="[editor.isActive({ textAlign: 'center' }) ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="align-center" />
          </button>

          <button
            type="button"
            @click="editor.chain().focus().setTextAlign('right').run()"
            class="btn"
            :class="[editor.isActive({ textAlign: 'right' }) ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="align-right" />
          </button>
          <button
            type="button"
            @click="editor.chain().focus().setTextAlign('justify').run()"
            class="btn"
            :class="[editor.isActive({ textAlign: 'justify' }) ? 'btn-secondary' : 'border-0']"
          >
            <font-awesome-icon icon="align-justify" />
          </button>
        </div>
      </section>

      <div class="border-start border-2 mx-2"></div>

      <!-- Tabelle einfügen -->
      <section>
        <button type="button" class="btn border-0" @click="addTable()">
          <font-awesome-icon icon="table" />
        </button>
      </section>

      <div class="border-start border-2 mx-2"></div>

      <section>
        <button
          type="button"
          class="btn border-0"
          @click="
            editor.chain().focus().unsetAllMarks().run();
            editor.chain().focus().clearNodes().run();
          "
        >
          <font-awesome-icon icon="text-slash" />
        </button>
        <!-- <div class="border-start border-2 mx-2"></div> -->
      </section>
    </div>

    <div v-if="editor.can().deleteTable()" class="control-group d-flex justify-content-center mb-3 mx-1">
      <!-- Spalten -->
      <section>
        <button class="btn border-0 me-2" @click="editor.chain().focus().addColumnAfter().run()" :disabled="!editor.can().addColumnAfter()">
          <font-awesome-icon icon="plus" /> Spalte
        </button>

        <button class="btn border-0" @click="editor.chain().focus().deleteColumn().run()" :disabled="!editor.can().deleteColumn()">
          <font-awesome-icon icon="xmark" /> Spalte
        </button>
      </section>

      <div class="border-start border-2 mx-2"></div>

      <!-- Zeilen -->
      <section>
        <button class="btn border-0 me-2" @click="editor.chain().focus().addRowAfter().run()" :disabled="!editor.can().addRowAfter()">
          <font-awesome-icon icon="plus" /> Zeile
        </button>

        <button class="btn border-0" @click="editor.chain().focus().deleteRow().run()" :disabled="!editor.can().deleteRow()">
          <font-awesome-icon icon="xmark" /> Zeile
        </button>
      </section>

      <div class="border-start border-2 mx-2"></div>

      <section>
        <div class="dropdown">
          <button class="btn border-0 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">Rahmen</button>
          <ul class="dropdown-menu p-0">
            <li class="p-2 table-border-select" @click="setTableBorder('none')">Kein Rahmen</li>
            <li class="p-2 table-border-select" @click="setTableBorder('all')">Alle Rahmen</li>
            <li class="p-2 table-border-select" @click="setTableBorder('left')">Rahmen links</li>
            <li class="p-2 table-border-select" @click="setTableBorder('top')">Rahmen oben</li>
            <li class="p-2 table-border-select" @click="setTableBorder('right')">Rahmen rechts</li>
            <li class="p-2 table-border-select" @click="setTableBorder('bottom')">Rahmen unten</li>
          </ul>
        </div>
      </section>

      <div class="border-start border-2 mx-2"></div>

      <section>
        <button class="btn border-0" @click="editor.chain().focus().deleteTable().run()" :disabled="!editor.can().deleteTable()">
          <font-awesome-icon icon="trash" /> Tabelle
        </button>
      </section>
    </div>

    <div class="bg-white editor-container rounded border p-3 mx-auto" @click="setEditorFocus">
      <editor-content :editor="editor" ref="editorContentRef" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  //#region Imports
  import { watch, PropType, ref } from 'vue';

  import { StarterKit } from '@tiptap/starter-kit';
  import { mergeAttributes } from '@tiptap/core';
  import Highlight from '@tiptap/extension-highlight';
  import TextAlign from '@tiptap/extension-text-align';
  import { Color } from '@tiptap/extension-color';
  import ListItem from '@tiptap/extension-list-item';
  import Subscript from '@tiptap/extension-subscript';
  import Superscript from '@tiptap/extension-superscript';
  import TextStyle from '@tiptap/extension-text-style';
  import Underline from '@tiptap/extension-underline';

  import Table from '@tiptap/extension-table';
  import TableHeader from '@tiptap/extension-table-header';
  import TableRow from '@tiptap/extension-table-row';
  import TableCell from '@tiptap/extension-table-cell';

  import { useEditor, EditorContent } from '@tiptap/vue-3';
  //#endregion

  const props = defineProps({
    modelValue: {
      type: String as PropType<string>,
      default: '',
    },
  });

  const emit = defineEmits(['update:modelValue']);

  //#region Table Functions

  const CustomTableCell = TableCell.extend({
    addAttributes() {
      return {
        // extend the existing attributes …
        ...this.parent?.(),

        // and add a new one …
        border: {
          default: 'solid 1px black',
          // default: '',
          parseHTML: (element) => element.getAttribute('data-border'),
          renderHTML: (attributes) => {
            return {
              'data-border': attributes.border,
              style: `border: ${attributes.border}`,
            };
          },
        },

        borderLeft: {
          default: null,
          parseHTML: (element) => element.getAttribute('data-border-left'),
          renderHTML: (attributes) => {
            return {
              'data-border-left': attributes.borderLeft,
              style: `border-left: ${attributes.borderLeft}`,
            };
          },
        },

        borderTop: {
          default: null,
          parseHTML: (element) => element.getAttribute('data-border-top'),
          renderHTML: (attributes) => {
            return {
              'data-border-top': attributes.borderTop,
              style: `border-top: ${attributes.borderTop}`,
            };
          },
        },

        borderRight: {
          default: null,
          parseHTML: (element) => element.getAttribute('data-border-right'),
          renderHTML: (attributes) => {
            return {
              'data-border-right': attributes.borderRight,
              style: `border-right: ${attributes.borderRight}`,
            };
          },
        },

        borderBottom: {
          default: null,
          parseHTML: (element) => element.getAttribute('data-border-bottom'),
          renderHTML: (attributes) => {
            return {
              'data-border-bottom': attributes.borderBottom,
              style: `border-bottom: ${attributes.borderBottom}`,
            };
          },
        },
      };
    },

    renderHTML({ HTMLAttributes }) {
      const attrs = mergeAttributes(this.options.HTMLAttributes, HTMLAttributes);

      if (attrs.colwidth) {
        if (attrs.style.width != undefined) {
          attrs.style.width = `${attrs.colwidth}px`;
        } else {
          if (attrs.style == null) {
            attrs.style = '';
          }
          if (attrs.style.length > 0) {
            attrs.style += '; ';
          }

          attrs.style += `width: ${attrs.colwidth}px;`;
        }
        // attrs.style.width = `${attrs.colwidth}px`;
      }

      return ['td', attrs, 0];
    },
  });

  function addTable() {
    editor.value?.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: false }).run();
  }

  function setTableBorder(border: string) {
    if (border === 'none') {
      removeAllTableBorders();
    } else if (border === 'all') {
      if (editor.value?.can().setCellAttribute('border', '1px solid black')) {
        editor.value?.chain().focus().setCellAttribute('border', '1px solid black').run();

        editor.value
          ?.chain()
          .focus()
          .setCellAttribute('borderLeft', null)
          .setCellAttribute('borderTop', null)
          .setCellAttribute('borderRight', null)
          .setCellAttribute('borderBottom', null)
          .run();
      } else {
        editor.value?.chain().focus().setCellAttribute('border', 0).run();
      }
    } else if (border === 'left') {
      editor.value?.chain().focus().setCellAttribute('border', 0).run();

      if (editor.value?.can().setCellAttribute('borderLeft', '1px solid black')) {
        editor.value?.chain().focus().setCellAttribute('borderLeft', '1px solid black').run();
      } else {
        editor.value?.chain().focus().setCellAttribute('borderLeft', 0).run();
      }
    } else if (border === 'top') {
      editor.value?.chain().focus().setCellAttribute('border', 0).run();

      if (editor.value?.can().setCellAttribute('borderTop', '1px solid black')) {
        editor.value?.chain().focus().setCellAttribute('borderTop', '1px solid black').run();
      } else {
        editor.value?.chain().focus().setCellAttribute('borderTop', 0).run();
      }
    } else if (border === 'right') {
      editor.value?.chain().focus().setCellAttribute('border', 0).run();

      if (editor.value?.can().setCellAttribute('borderRight', '1px solid black')) {
        editor.value?.chain().focus().setCellAttribute('borderRight', '1px solid black').run();
      } else {
        editor.value?.chain().focus().setCellAttribute('borderRight', 0).run();
      }
    } else if (border === 'bottom') {
      editor.value?.chain().focus().setCellAttribute('border', 0).run();

      if (editor.value?.can().setCellAttribute('borderBottom', '1px solid black')) {
        editor.value?.chain().focus().setCellAttribute('borderBottom', '1px solid black').run();
      } else {
        editor.value?.chain().focus().setCellAttribute('borderBottom', 0).run();
      }
    }
  }

  function removeAllTableBorders() {
    editor.value?.chain().focus().setCellAttribute('border', 0).run();
    editor.value?.chain().focus().setCellAttribute('borderLeft', 0).run();
    editor.value?.chain().focus().setCellAttribute('borderTop', 0).run();
    editor.value?.chain().focus().setCellAttribute('borderRight', 0).run();
    editor.value?.chain().focus().setCellAttribute('borderBottom', 0).run();
  }
  //#endregion

  // Editor initialisieren
  const editor = useEditor({
    extensions: [
      StarterKit, // StarterKit enthält grundlegende Funktionen wie bold, italic, usw.
      Color.configure({ types: [TextStyle.name, ListItem.name] }),
      TextStyle,
      TextAlign.configure({
        types: ['heading', 'paragraph'],
      }),
      Underline,
      Highlight.configure({
        multicolor: true,
      }),
      Subscript,
      Superscript,

      Table.configure({
        // optional: Spalten-Width-Resize erlauben
        resizable: true,
      }),
      TableRow,
      TableHeader,
      // TableCell,
      // TableResizing,
      CustomTableCell,
    ],
    editorProps: {
      handlePaste(view, event) {
        // löscht alle Formattierungen beim Einfügen
        let text = event.clipboardData?.getData('text/plain') || '';
        view.dispatch(view.state.tr.insertText(text));
        return true;
      },
    },
    content: props.modelValue || '', // Initialen Content setzen
    onUpdate: ({ editor }) => {
      // Sobald der Inhalt aktualisiert wird, wird das modelValue ausgegeben
      emit('update:modelValue', editor.getHTML());
    },
  });

  // Wenn der Inhalt von außen geändert wurde, wird der Inhalt des Editors aktualisiert
  watch(
    () => props.modelValue,
    (newValue) => {
      if (editor.value) {
        // Nur aktualisieren, wenn sich der Inhalt wirklich unterscheidet
        const current = (editor.value.getHTML() || '').trim();
        const incoming = (newValue || '').trim();
        if (current !== incoming) {
          editor.value.commands.setContent(newValue || '');
        }
      }
    }
  );

  // function copyHTML() {
  //   const content = editor.value?.getHTML() || 'kein Inhalt';
  //   navigator.clipboard.writeText(content);
  // }

  // function copyJSON() {
  //   const content = JSON.stringify(editor.value?.getJSON()) || 'kein Inhalt';
  //   console.log(content);

  //   navigator.clipboard.writeText(content);
  // }

  const editorContentRef = ref();

  function setEditorFocus(_event: MouseEvent) {
    if (!editor.value) return;

    const editorEl = editorContentRef.value?.rootEl;
    if (!editorEl) return;

    const selection = window.getSelection();

    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      if (!editorEl.contains(range.startContainer)) {
        // Wenn nicht in den Text geklickt wurde, Cursor ans Ende setzen
        editor.value.commands.focus('end');
      }
    } else {
      // Falls keine Selektion vorhanden ist, Cursor ebenfalls ans Ende setzen
      editor.value.commands.focus('end');
    }

    // if (selection)
  }
</script>

<style lang="scss">
  .editor-container {
    // min-height: 268mm; /* A4 Höhe */
    min-height: 90mm;
    width: 190mm; /* A4 Breite */
    position: relative;
  }

  .table-border-select:hover {
    background-color: #e6e6e6;
    cursor: pointer;
  }

  .ProseMirror:focus {
    outline: none;
  }

  /* Basic editor styles */
  .tiptap {
    :first-child {
      margin-top: 0;
    }

    /* List styles */
    ul,
    ol {
      padding: 0 1rem;
      margin: 1.25rem 1rem 1.25rem 0.4rem;

      li p {
        margin-top: 0.25em;
        margin-bottom: 0.25em;
      }
    }

    /* Heading styles */
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      line-height: 1.1;
      margin-top: 2.5rem;
      text-wrap: pretty;
    }

    h1,
    h2 {
      margin-top: 3.5rem;
      margin-bottom: 1.5rem;
    }

    h1 {
      font-size: 1.4rem;
    }

    h2 {
      font-size: 1.2rem;
    }

    h3 {
      font-size: 1.1rem;
    }

    h4,
    h5,
    h6 {
      font-size: 1rem;
    }

    /* Code and preformatted text styles */
    code {
      background-color: var(--purple-light);
      border-radius: 0.4rem;
      color: var(--black);
      font-size: 0.85rem;
      padding: 0.25em 0.3em;
    }

    pre {
      background: var(--black);
      border-radius: 0.5rem;
      color: var(--white);
      font-family: 'JetBrainsMono', monospace;
      margin: 1.5rem 0;
      padding: 0.75rem 1rem;

      code {
        background: none;
        color: inherit;
        font-size: 0.8rem;
        padding: 0;
      }
    }

    mark {
      background-color: #faf594;
      border-radius: 0.4rem;
      box-decoration-break: clone;
      padding: 0.1rem 0.3rem;
    }

    blockquote {
      border-left: 3px solid var(--gray-3);
      margin: 1.5rem 0;
      padding-left: 1rem;
    }

    hr {
      border: none;
      border-top: 1px solid var(--gray-2);
      margin: 2rem 0;
    }

    /* Table-specific styling */
    table {
      border-collapse: collapse;
      margin: 0;
      overflow: hidden;
      table-layout: fixed;
      max-width: 100%;
      // width: 170mm;
      /* width: 100%; */

      td,
      th {
        border: 1px solid var(--gray-3);
        box-sizing: border-box;
        min-width: 1em;
        padding: 6px 8px;
        position: relative;
        vertical-align: top;

        > * {
          margin-bottom: 0;
        }
      }

      th {
        background-color: var(--gray-1);
        font-weight: bold;
        text-align: left;
      }

      p {
        margin-bottom: 1rem;
      }

      td p:last-of-type {
        margin-bottom: 0;
      }

      .selectedCell:after {
        background: var(--gray-2);
        content: '';
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        pointer-events: none;
        position: absolute;
        z-index: 2;
      }

      .column-resize-handle {
        background-color: var(--purple);
        bottom: -2px;
        pointer-events: none;
        position: absolute;
        right: -2px;
        top: 0;
        width: 4px;
      }
    }

    .tableWrapper {
      margin: 1.5rem 0;
      overflow-x: auto;
    }

    &.resize-cursor {
      cursor: ew-resize;
      cursor: col-resize;
    }
  }

  /* Table styles */
  // .ProseMirror table {
  //   border-collapse: collapse;
  //   border: 1px solid black;
  //   margin: 1rem 0;
  // }
  // .ProseMirror th,
  // .ProseMirror td {
  //   border: 1px solid black;
  //   padding: 0.2rem;
  // }
  // .ProseMirror td p {
  //   // border: 1px solid black;
  //   // padding: 0.5rem;
  //   padding: 0;
  //   margin: 0;
  // }

  .orange-cirlce {
    width: 16px;
    height: 16px;
    background-color: #ffa500;
    border-radius: 50%;
  }
</style>
